<template>
  <v-layout row justify-center>
    <v-dialog v-model="dialog" persistent max-width="600px">
      <v-form
        ref="form"
        v-model="valid"
        lazy-validation>
        <v-card class="insights-dialog">
          <v-card-title>
            <span class="headline"><v-icon class="pr-2">add_circle_outline</v-icon>Historic Daily Rankings</span>
          </v-card-title>
          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>

                <v-flex xs18 sm9 md6>
                  <v-menu
                    :close-on-content-click="false"
                    v-model="menu1"
                    :nudge-right="40"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    min-width="290px"
                  >
                    <v-text-field
                      slot="activator"
                      v-model="form.dateFrom"
                      label="From*"
                      prepend-icon="event"
                      readonly
                      :rules="[rules.required]"
                      required
                    ></v-text-field>
                    <v-date-picker v-model="form.dateFrom"
                                   @input="menu1 = false"
                                   min="1990-01-01"
                                   :max=currentDate
                                   required
                                   no-title></v-date-picker>
                  </v-menu>
                </v-flex>
                <v-flex xs18 sm9 md6>
                  <v-menu
                    :close-on-content-click="false"
                    v-model="menu2"
                    :nudge-right="40"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    min-width="290px"
                  >
                    <v-text-field
                      slot="activator"
                      v-model="form.dateTo"
                      label="To*"
                      prepend-icon="event"
                      readonly
                      :rules="[rules.required]"
                      required
                    ></v-text-field>
                    <v-date-picker v-model="form.dateTo"
                                   @input="menu2 = false"
                                   min="1990-01-01"
                                   :max=currentDate
                                   required
                                   no-title></v-date-picker>
                  </v-menu>
                </v-flex>
                <v-flex xs12>
                  <v-text-field label="URL*"
                                v-model="form.anUrl"
                                hint="http(s)://"
                                :rules="[rules.required, rules.anURL]"
                                required></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-checkbox
                    v-model="form.showAll"
                    color="primary"
                    label="Show all"
                  ></v-checkbox>
                </v-flex>
                <v-flex xs12>
                  <v-select
                    v-model="form.engine_id"
                    :items="selectEngine"
                    item-text="name"
                    item-value="id"
                    label="Search engine*"
                    required
                    data-vv-name="add_project.engine_id"
                    :error-messages="errors.collect('add_project.engine_id')"
                  >
                    <template slot="item" slot-scope="data">
                      <v-icon class="pr-2 engine-flag-icon">{{ data.item.country_css }}</v-icon>
                      <v-icon class="pr-2 engine-device-icon">{{ data.item.device_css }}</v-icon>
                      {{ data.item.name }}
                    </template>
                  </v-select>
                </v-flex>
                <v-flex xs12>
                  <v-checkbox
                    v-model="form.sendEmail"
                    color="primary"
                    label="Email me when report is ready"
                  ></v-checkbox>
                </v-flex>
              </v-layout>
              <span><v-icon class="pr-2">info</v-icon>Reports are usually generated within a few minutes. However, it can take longer based on the date range selected.</span>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn v-on:click="closeDialog" color="blue darken-1" flat>Close</v-btn>
            <v-btn v-on:click="validate" color="blue darken-1" flat>Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
  </v-layout>
</template>

<script>
import InsightMixin from '../../mixins/insightMixin'

let aDate = new Date()
let toDate = new Date()
aDate.setDate(aDate.getDate() - 1)
export default {
  name: 'daily-rankings',
  props: {
    dialog: {
      default: false,
      type: Boolean
    }
  },
  mixins: [InsightMixin],
  data () {
    return {
      name: 'daily-rankings',
      form: {
        dateFrom: aDate.toISOString().substr(0, 10),
        dateTo: toDate.toISOString().substr(0, 10),
        anUrl: '',
        sendEmail: true,
        showAll: false,
        engine_id: 1
      },
      result: {
        type: 1,
        from_date: aDate.toISOString().substr(0, 10),
        to_date: toDate.toISOString().substr(0, 10),
        params: {
          url: '',
          send_email: true,
          show_all: false,
          engine_id: 1
        }
      },
      currentDate: new Date().toISOString().substr(0, 10),
      menu1: false,
      menu2: false
    }
  },
  methods: {
    formToResult () {
      this.result.from_date = this.form.dateFrom
      this.result.to_date = this.form.dateTo
      this.result.params.url = this.form.anUrl
      this.result.params.send_email = this.form.sendEmail
      this.result.params.show_all = this.form.showAll
      this.result.params.engine_id = this.form.engine_id
    },
    resetForm () {
      this.form = {
        dateFrom: aDate.toISOString().substr(0, 10),
        dateTo: toDate.toISOString().substr(0, 10),
        anUrl: '',
        sendEmail: true,
        showAll: false,
        engine_id: 1
      }
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/insights-dialog/DailyRankings.vue